import React from 'react';

/**
 * Gallery device shell. The surface colour is inherited from the mounted
 * screen so dark screens never sit on a light canvas while they render.
 */
export function PhoneFrame({
  children,
  title,
  dark = false
}: {
  children: React.ReactNode;
  title?: string;
  dark?: boolean;
}) {
  const surface = dark ? 'bg-[#061827]' : 'bg-brand-cloud';
  return <div className="flex w-full max-w-[390px] flex-col items-center gap-4" data-id="element-131" data-mp="22mz5hpqftm6g">
      {title && <h2 className="text-center text-sm font-extrabold tracking-tight text-brand-navy" data-id="element-132" data-mp="27jpl6bybyfrc">{title}</h2>}
      <div className={`relative flex aspect-[390/844] w-full flex-col overflow-hidden rounded-[42px] border-[7px] border-[#04111d] shadow-[0_35px_90px_-35px_rgba(6,24,39,.65)] ${surface}`} data-id="element-133" data-mp="2bjrdvvm37yuh">
        <div className="pointer-events-none absolute inset-x-0 top-0 z-50 flex h-7 justify-center" data-id="element-134" data-mp="2lj8i08loy4oc">
          <div className="h-[29px] w-[122px] rounded-b-[18px] bg-[#04111d]" data-id="element-135" data-mp="m87dvf148iy7" />
        </div>
        <div className={`pointer-events-none absolute inset-x-0 top-0 z-40 flex h-11 items-center justify-between px-6 text-[13px] font-extrabold ${dark ? 'text-white' : 'text-brand-navy'}`} data-id="element-136" data-mp="r6iq1wevv5jl">
          <span data-id="element-137" data-mp="3459kudyj0zkm">9:41</span>
          <span className="tracking-[.2em]" data-id="element-138" data-mp="343yhgf8zttu1">●◒▰</span>
        </div>
        <div className={`phone-scroll relative h-full w-full flex-1 overflow-y-auto ${surface}`} data-id="element-139" data-mp="2z7zveyb50nws">{children}</div>
      </div>
    </div>;
}